import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type { PaginatedData } from '#src/app/shared/contexts/asyncData';

import type { TopicSitemapDataQuery, TopicSitemapDataQueryVariables } from './api.graphql';
import { TopicSitemapData } from './api.graphql';
import type { TopicPageSitemapItem } from './types';

export type TopicSitemapPageData = PaginatedData<TopicPageSitemapItem, { totalCount: number }>;
export type Topics = TopicSitemapDataQuery['topics']['nodes'];

async function getData(
	{ gql: { fetch } }: UtilityContext,
	queryParams: { startsWith?: string | undefined },
	cursor?: string,
): Promise<TopicSitemapPageData> {
	const { data } = await fetch<TopicSitemapDataQuery, TopicSitemapDataQueryVariables>({
		query: TopicSitemapData,
		variables: { cursor: cursor ?? null, startsWith: queryParams.startsWith ?? null },
		rejectOnError: true,
	});

	return {
		items: data.topics.nodes,
		cursor: data.topics.pageInfo.endCursor,
		hasNextPage: data.topics.pageInfo.hasNextPage,
		totalCount: data.topics.totalCount,
	};
}

export async function getFirstPageData(
	utilityContext: UtilityContext,
	queryParams: { startsWith?: string | undefined },
) {
	return getData(utilityContext, queryParams);
}
export async function getNextPageData(
	utilityContext: UtilityContext,
	cursor: string,
	queryParams: { startsWith?: string | undefined },
) {
	return getData(utilityContext, queryParams, cursor);
}
